import { Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

import { SetupToaster } from './setup-toaster'

export const RootLayout = (): React.ReactNode => (
    <>
        <Outlet />
        <TanStackRouterDevtools />
        <SetupToaster />
    </>
)
